export default "__VITE_ASSET__5b4cbff3__"